import { render, staticRenderFns } from "./WrapperDrawer.vue?vue&type=template&id=72cf607c&scoped=true"
import script from "./WrapperDrawer.vue?vue&type=script&lang=js"
export * from "./WrapperDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf607c",
  null
  
)

export default component.exports